import { Box, Grow } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import axiosInstant from "../../../../api";
import { ContentWrapper } from "../../../../components/ContentWrapper/ContentWrapper";
import { useUser } from "../../../../hooks/useUser";
import { getBrandEmbeds, deleteEmbed } from "../../../../api/endpoints";
import { SelectedEmbedCardV2 } from "../components/selectedEmbedV2";
import { SelectedVideoV2 } from "../../videos/selectedVideoCardV2";
import { EmbedListV2 } from "./EmbedList";
import { WhiteBackground } from "../../../../components/WhiteBackground";

export function EmbedV2Listing() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedEmbedId, setSelectedEmbedId] = useState<null | number>(null);
  const [loading, setLoading] = useState(true);
  const [embeds, setEmbeds] = useState<any[]>([]);
  const [count, setCount] = useState(0);
  const [videoId, setVideoId] = useState<number | null>(null);

  const isEmbedSelected = useMemo(
    () => selectedEmbedId !== null,
    [selectedEmbedId]
  );
  const { brand } = useUser();
  const brandId: number = brand?.[0]?.id || 0;

  const fetchEmbeds = async () => {
    setLoading(true);
    const productId = searchParams.get("productId") || "";
    const searchPhrase = searchParams.get("search") || "";
    const limit = parseInt(searchParams.get("limit") || "20", 10);
    const response = await axiosInstant.get(
      getBrandEmbeds(brandId, limit, 1, searchPhrase, productId)
    );
    const { data } = response;
    setEmbeds(data.rows);
    setCount(data.count);
    setLoading(false);
  };

  useEffect(() => {
    const embedId = searchParams.get("embed");
    setSelectedEmbedId(embedId ? parseInt(embedId, 10) : null);

    const video = searchParams.get("video");
    setVideoId(video ? parseInt(video, 10) : null);
  }, [searchParams]);

  const handleDeleteEmbed = async (i: number) => {
    if (embeds) {
      const embedId = embeds[i]?.id;
      if (embedId) {
        try {
          await deleteEmbed(embedId);
          const endpoint = deleteEmbed(embedId);
          await axiosInstant.delete(endpoint);
          setEmbeds(
            (oldValues) => oldValues?.filter((val, ii) => i !== ii) || []
          );
          toast.success("Story Deleted");
          resetSelectedEmbed();
          setSelectedEmbedId(null);
        } catch (e) {
          toast.success("Story Not Deleted");
        }
      }
    }
  };

  const handleResetVideo = () => {
    setSearchParams((params) => {
      params.delete("video");
      params.delete("selectedTab");
      return params;
    });
    setVideoId(null);
  };

  const resetSelectedEmbed = () => {
    setSelectedEmbedId(null);
    setSearchParams();
  };

  const props = { loading, embeds, count };
  return (
    <WhiteBackground>
      <ContentWrapper>
        {videoId && (
          <Box flexGrow={1}>
            <SelectedVideoV2
              videoId={videoId}
              onClose={handleResetVideo}
              type="file"
              refetch={resetSelectedEmbed}
            />
          </Box>
        )}
        {!videoId && selectedEmbedId && (
          <Grow in={isEmbedSelected}>
            <Box flexGrow={1}>
              <SelectedEmbedCardV2
                brandId={brandId}
                embedId={selectedEmbedId}
                onClose={() => resetSelectedEmbed()}
                onUpdate={fetchEmbeds}
                onDelete={() => {
                  const index = embeds.findIndex(
                    (e) => e.id === selectedEmbedId
                  );
                  if (index > -1) handleDeleteEmbed(index);
                }}
              />
            </Box>
          </Grow>
        )}
        {!videoId && !selectedEmbedId && (
          <EmbedListV2
            {...props}
            refetchEmbeds={fetchEmbeds}
            onDeleteEmbed={handleDeleteEmbed}
          />
        )}
      </ContentWrapper>
    </WhiteBackground>
  );
}
